export default "__VITE_ASSET__K$6UhBpQKwz9BGvGCbTiow__"